import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import pl from './locales/pl.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

import tabsPL from './Menu/tabs.pl.json';
import tabsEN from './Menu/tabs.en.json';
import tabsAR from './Menu/tabs.ar.json';

import welcomePL from './locales/welcome.pl.json';
import welcomeEN from './locales/welcome.en.json';
import welcomeAR from './locales/welcome.ar.json';

const resources = {
  pl: { translation: { ...pl, menuTabs: tabsPL, welcome: welcomePL } },
  en: { translation: { ...en, menuTabs: tabsEN, welcome: welcomeEN } },
  ar: { translation: { ...ar, menuTabs: tabsAR, welcome: welcomeAR } }
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'pl', // Default language (Polish)
    lng: 'pl', // Set initial language to Polish
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

export default i18n;